import { Injectable } from '@angular/core';
import { Http , Response } from '@angular/http';

@Injectable()
export class InformationService {
   private _descriptionUrl='/assets/txt/description.txt';
   private _timelineUrl='/assets/json/timeline.json';
   private _projectsUrl='/assets/json/projects.json';
   private _languagesUrl='/assets/json/languages.json';
   private _awardsUrl='/assets/json/awards.json';
   private _othersUrl='/assets/json/others_info.json';
   private _technicalUrl='/assets/json/technical.json';

   response_re : string;
   constructor(private _http: Http){}
   
   async getDescription(): Promise<string> {
      const response = await this._http.get(this._descriptionUrl).toPromise();
      return response.text();
   }

    getTimeline(){
    return this._http.get(this._timelineUrl);
   }

   getProjects(){
    return this._http.get(this._projectsUrl);
   }

   getLanguages(){
    return this._http.get(this._languagesUrl);
   }

   getAwards(){
    return this._http.get(this._awardsUrl);
   }

   getOthers(){
    return this._http.get(this._othersUrl);
   }

   getTechnical(){
    return this._http.get(this._technicalUrl);
   }
}